import React, { useEffect, useState } from "react";
import { Container, Form, Table } from "react-bootstrap";
import { MdOutlinePushPin, MdPushPin } from "react-icons/md";
import { useSelector } from "react-redux";
import { apiGetOrgunits } from "../../api/ApiOrgunit";
import { apiGetProcesses, apiUpdateProcess } from "../../api/ApiProcess";
import ComponentMenu from "../../components/layout/ComponentMenu";
import ComponentSousTitle from "../../components/layout/ComponentSousTitle";
import ComponentTitle from "../../components/layout/ComponentTitle";
import { useTranslation } from "react-i18next";
import { BiHide } from "react-icons/bi";

const PageAdminPinnedOrgunits = () => {
  const { t } = useTranslation();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const [processes, setProcesses] = useState([]);
  //   const [selectedProcess, setSelectedProcess] = useState("");

  useEffect(() => {
    getProcesses();
  }, []);

  //   useEffect(() => {
  //     if (selectedProcess) {
  //       setOrgunits(selectedProcess.orgunits);
  //     } else {
  //       setOrgunits([]);
  //     }
  //   }, [selectedProcess]);

  const getProcesses = async () => {
    const res = await apiGetProcesses(
      ReduxInstance._id,
      "filter[famille]=MacroProcess&include=orgunits&sort[ordre]=-1"
    );
    if (res) {
      setProcesses(res.data);
    } else {
      console.log("Hey");
    }
  };

  const handlePinOrgunit = (process, orgunitId) => {
    // let _orgunitsPinned = processes.find(
    //   (process) => process._id === processId
    // ).orgunitsPinned;
    let _orgunitsPinned = process.orgunitsPinned;

    if (_orgunitsPinned) {
      if (_orgunitsPinned.find((orgunit) => orgunit === orgunitId)) {
        _orgunitsPinned = _orgunitsPinned.filter((orgunit) => orgunit !== orgunitId);
      } else {
        _orgunitsPinned.push(orgunitId);
      }
    } else {
      _orgunitsPinned = [orgunitId];
    }

    // let formData = new FormData();
    // formData.append("orgunitsPinned[]", [_orgunitsPinned]);
    let formData = {
      orgunitsPinned: _orgunitsPinned,
    };
    updateProcess(process._id, formData);

    // setSelectedProcess({
    //   ...selectedProcess,
    //   orgunitsPinned: _orgunitsPinned,
    // });
  };

  const updateProcess = async (processId, form) => {
    const res = await apiUpdateProcess(processId, form);
    if (res) {
      getProcesses();
    } else {
      console.log("error");
    }
  };

  const getTradType = (type) => {
    switch (type) {
      case "Rituel":
        return t("commun.form.select.rituel");
      case "Rôle":
        return t("commun.form.select.role");
      case "Temps collectif":
        return t("commun.form.select.tempsCollectif");
      case "Partie prenante":
        return t("commun.form.select.partiePrenante");

      default:
        return null;
    }
  };

  const OrgunitLine = ({ orgunit, process }) => {
    return (
      <tr>
        <td>
          {orgunit.enSommeil && <BiHide size="1.5em" className="orgunitAdminHiddenButton me-2" />}
          {orgunit.nom}
        </td>
        <td className="text-center">{getTradType(orgunit.type)}</td>
        <td className="text-center">
          {process.orgunitsPinned.find((_org) => _org === orgunit._id) ? (
            <MdPushPin
              size="1.5em"
              role="button"
              onClick={() => handlePinOrgunit(process, orgunit._id)}
            />
          ) : (
            <MdOutlinePushPin
              size="1.5em"
              role="button"
              onClick={() => handlePinOrgunit(process, orgunit._id)}
            />
          )}
        </td>
      </tr>
    );
  };

  return (
    <>
      <ComponentMenu />
      <Container>
        <ComponentTitle title={t("admin.PageAdminPinnedOrgunits.titre")} />
        {/* <Form.Select
          name="orgunitPrincipalInOperation"
          value={selectedProcess._id}
          onChange={(e) => handleSelectProcess(e.target.value)}
        >
          <option value="">Sélectionner un processus</option>
          {processes.map((process, index) => (
            <option value={process._id} key={"process_" + index}>
              {process.nom}
            </option>
          ))}
        </Form.Select> */}

        {/* <pre>{JSON.stringify(selectedProcess, null, 4)}</pre> */}

        {processes.map((process) => (
          <div key={process._id}>
            <ComponentSousTitle nom={process.nom} />
            <Table striped bordered hover className="stickyTable mt-2">
              <thead>
                <tr>
                  <th>{t("admin.PageAdminPinnedOrgunits.titreColonne1")}</th>
                  <th className="text-center">
                    {t("admin.PageAdminPinnedOrgunits.titreColonne2")}
                  </th>
                  <th className="text-center">
                    {t("admin.PageAdminPinnedOrgunits.titreColonne3")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {process.orgunits
                  ? process.orgunits
                      .filter((orgunit) => orgunit.type !== "")
                      .sort((a, b) => (a.type > b.type ? 1 : -1))
                      .map((orgunit) => (
                        <OrgunitLine
                          key={process._id + orgunit._id}
                          orgunit={orgunit}
                          process={process}
                        />
                      ))
                  : null}
              </tbody>
            </Table>
          </div>
        ))}
      </Container>
    </>
  );
};

export default PageAdminPinnedOrgunits;
